module.exports = __webpack_public_path__ + "img/iconos-categorias-04.84705cc1.svg";